import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ProgressScreen from '../screen'


const ProgressRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.PROGRESS} component={ProgressScreen} />
        </React.Fragment>
    )
}

export default ProgressRoutes